export class SecurityGroupSearchConditionView {
    public securityGroupName: string;
    public securityCode: string;
    public securityName: string;
    public userLogon: string;
    public action: string;
    public statusCode: string;
}